module.exports = {"title":"手机及装置"}


//////////////////
// WEBPACK FOOTER
// ./src/locale/mobileDevice/zh-cn.json
// module id = rmtC
// module chunks = 1